import { faCheck, faCogs } from "@fortawesome/free-solid-svg-icons";
import { Dispatch, SetStateAction } from "react";
import UnForm from "../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../Context/AtendimentoPage";
import { useHistoricoContext } from "../../../../../Context/Historico";
import { AtualizarDadosControleReparoController } from "../../../../../Controllers/AssistenciaTecnica/GerenciarControleReparo/GerenciarControleReparoController";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { AlertConfirmation } from "../../../../../Tools/SweetAlerts";
import DadosManutencao from "./DadosManutencao"; 
import { IGerenciarControleReparo } from "../../../../../Interfaces/AssistenciaTecnica/GerenciarControleReparo/GerenciarControleReparoInterface";

interface IGerenciarControleReparoProps {
    setShow: Dispatch<SetStateAction<boolean>>;
}

export default function GerenciarControleReparo(props: IGerenciarControleReparoProps) {
    const { updateAtendimento, ID_CASO, Atendimento } = useAtendimentoPage();

    const { ReloadHistorico } = useHistoricoContext();

    const { execute: editarDadosManutencao, loading } = useAsyncCallback(
        AtualizarDadosControleReparoController
    );

    const editarManutencao = (
        formData: IGerenciarControleReparo
    ) => {
        AlertConfirmation(
            `Tem certeza que deseja editar os dados da manutenção?`,
            "",
            undefined,
            { cancelButtonText: "Não", confirmButtonText: "Sim" }
        ).then((response) => {
            if (response.isConfirmed) {
                editarDadosManutencao({...formData, ID_CASO})
                    .then(() => {
                        updateAtendimento();
                        ReloadHistorico();
                    })
                    .then(() => {
                        props.setShow(false);
                    });
            }
        });
    };

    return (
        <div>
            <UnForm handleSubmit={editarManutencao}>
                <DadosManutencao />

                <UnForm.SubmitButton
                    color="success"
                    wrapperClassName="w-100 mt-8"
                    className="w-100"
                    icon={faCheck}
                    loading={loading}
                    disabled={loading}
                    loadingSize={"sm"}
                >
                    Concluir
                </UnForm.SubmitButton>
            </UnForm>
        </div>
    );
}
